import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { instance2 } from "../utils/axiosInstance"; // Ensure the Axios instance path is correct
import CalendarIcon from "../img/calendaricon.svg"; // Replace with the correct path for your calendar icon
import { formatNumber } from "../numberingformat"; // Ensure formatNumber works for formatting
import DapurIcon from "../img/logodapursidebar.png";
import { basecode } from "./pesananscreen/baserobotocode";
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf"; // Import jsPDF for PDF generation
import "jspdf-autotable"; // Import the autotable plugin for jsPDF

export default function PenerimaanBahanSortByDapur() {
  //const [selectedDate, setSelectedDate] = useState(new Date());
  const [locationId, setLocationId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [editableRows, setEditableRows] = useState({});
  

    // Access state from the navigate call
    const location = useLocation();
  
    // Extract startDate and endDate from the URL query string
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
    const kitchenParam = parseInt(queryParams.get('kitchenId'),0) ?? parseInt(localStorage.getItem("kitchenId"), 10);;
  
  
const localDateString = (thedate) =>{

  const year = thedate.getFullYear();
  const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
  const day = String(thedate.getDate()).padStart(2, '0');
  
//console.log("startDate", thedate);
const localDateString = `${year}-${month}-${day}`;

return localDateString

}
  const getWeekStartAndEndDates = (date) => {
    const current = new Date(date);
    const dayOfWeek = current.getDay();
    const monday = new Date(startDate? startDate : current);
    monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return { startDate: localDateString(monday), endDate: localDateString(sunday)};
  };

  //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);

  const roleId = parseInt(localStorage.getItem("roleId"), 10);

  useEffect(() => {
    const storedLocationId = localStorage.getItem("locationId");
    if (storedLocationId && !isNaN(storedLocationId)) {
      const parsedId = parseInt(storedLocationId, 10);
      setLocationId(parsedId);
    }
  }, []);

  useEffect(() => {
    const fetchDataForDate = async (date) => {
      if (!locationId) {
        console.log("Location ID not yet available.");
        return;
      }
      let url
      try {
        setLoading(true);
        setError(null);

        kitchenParam ? url = `delivery_order_kitchen/id/${kitchenParam}/${localDateString(new Date(startDate))}` :
        url = `delivery_order/location/${locationId}/${localDateString(new Date(startDate))}/${localDateString(new Date(startDate))}`
        
        const response = await instance2.get(url);
        const retrievedData = response.data?.data || response.data || [];
        setData(retrievedData);

        // Set editable rows state
        const initialEditableState = retrievedData.reduce((acc, item, index) => {
          acc[index] = {
            //date_request: item.date_request,
            ingredient_id: item.ingredient_id,
            ingredient_name: item.ingredient_name,
            kitchen_id: item.kitchen_id,
            ingredient_value: item.qty,
            order_qty: item.order_qty,
            edited_qty: item.qty, // Initially, set it to ingredient_value
            remaining_qty: item.qty_request - item.ingredient_value, // Remaining qty after ingredient value is set
            qty_received: item.qty_received,
            cumulative_sum: item.qty_request, // Start the cumulative sum with ingredient_value
            uoq_id: item.uoq_id,
            uoq_code: item.uoq_code, // Start the cumulative sum with ingredient_value
            delivery_date: item.delivery_date, // Start the cumulative sum with ingredient_value
          };
          return acc;
        }, {});
        setEditableRows(initialEditableState);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    if (locationId) {
      fetchDataForDate(startDate);
    }
  }, [startDate, locationId]);

  const handleOrderQtyChange = (index, value) => {
    setEditableRows((prev) => {
      const updatedRows = { ...prev };
      updatedRows[index] = { ...updatedRows[index], edited_qty: value };
      return updatedRows;
    });
  };

  const calculateEditableQtyAndRemainingQty = (index, data) => {
    let editableQty, remainingQty, cumulativeSum;

    for (let i = 0; i <= index; i++) {    
      if (i > 0 && data[i].ingredient_name !== data[i - 1].ingredient_name) {
      cumulativeSum = (data[index].qty_received, editableRows[i].edited_qty);} else 
      cumulativeSum = parseInt(cumulativeSum? cumulativeSum : 0) + parseInt(editableRows[i]?.edited_qty );
    }
  
    // For the first row or when ingredient_name changes:
    // if (index === 0 || data[index - 1].ingredient_name !== data[index].ingredient_name) {
    //   editableQty = Math.min(data[index].qty_received, data[index].ingredient_value); // First row: Min of qty_received and ingredient_value
    //   remainingQty = (data[index].qty_received - cumulativeSum); // Remaining quantity after first row's edited_qty
    // } else {
      // For subsequent rows:
      // editable_qty is determined based on the previous remaining_qty and ingredient_value
      editableQty = Math.min(editableRows[index - 1]?.remaining_qty, data[index].qty_request); // Max between previous remaining qty and ingredient_value
      
      // Calculate cumulative sum for the current row
      
      // Calculate remaining qty after deducting cumulative sum
      remainingQty = (data[index]?.qty_received - cumulativeSum); // Calculate remaining qty
    // }
  
    return { editableQty, remainingQty, cumulativeSum };
  };
  
  const handleSubmit = async () => {
    const editedData = Object.values(editableRows).map((row) => ({
      id: row.id,
      qty: row.edited_qty, // Submit raw numeric value
      location_id: locationId, // Submit raw numeric value
      ingredient_id: row.ingredient_id, // Submit raw numeric value
      kitchen_id: row.kitchen_id, // Submit raw numeric value
      uoq_id: row.uoq_id, // Submit raw numeric value
      delivery_date: row.date_request, // Submit raw numeric value
      admin_id: localStorage.getItem("userAuthentication"), // Submit raw numeric value
      order_id: row.order_id, // Submit raw numeric value
    }));

    try {
      const response = await instance2.post("/delivery_order", {
        locationId,
        editedData,
      });

      if (response.status === "OK") {
        alert("Data submitted successfully");
      } else {
        alert("Submission failed");
      }
    } catch (error) {
      console.error("Error during submission", error);
      alert("An error occurred while submitting the data");
    }
  };

  const CustomInput = React.forwardRef(({ value, onClick, isOpen }, ref) => (
    <button
      className="flex items-center justify-between w-full px-4 py-2 border rounded-[15px] bg-white"
      onClick={onClick}
      ref={ref}
      type="button"
    >
      <div className="flex items-center gap-2">
        <img src={CalendarIcon} alt="Calendar" className="h-5 w-5 text-gray-500" />
        <div className="w-px h-5 bg-gray-300 mx-1 me-3"></div>
        <span>
          {new Date(value).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          })}
        </span>
      </div>
      <div
        className={`text-black font-semibold transform transition-transform duration-500 ease-in-out ${
          isOpen ? "rotate-180" : "rotate-0"
        }`}
      >
        ▼
      </div>
    </button>
  ));

  const handleDownloadPDF = async (locationName, kitchenName, kitchenId, data) => {
    const doc = new jsPDF();
  
    // Embed the Roboto font
    const robotoFont = basecode; // Replace with base64-encoded Roboto font data
    doc.addFileToVFS('Roboto-Regular.ttf', robotoFont);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    doc.setFont('Roboto', 'normal');
  
    // Convert local icon to Base64
    const loadImageAsBase64 = (imgSrc) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = imgSrc;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = (err) => reject(err);
      });
  
    // Load icon
    const iconBase64 = await loadImageAsBase64(DapurIcon);
  
    // Title and Supplier Information Block
    const pageWidth = doc.internal.pageSize.width;
    const text = 'DELIVERY ORDER';
    const textWidth = doc.getTextWidth(text);
    const xPosition = (pageWidth - textWidth) / 2;
  
    const addHeader = (doc, pageWidth, locationName, kitchenName) => {
      doc.setFontSize(12);
      // Check if xPosition and 10 (y position) are valid numbers
      if (!isNaN(xPosition) && !isNaN(10)) {
        doc.text(text, xPosition, 10); // Correct use of text method
      } else {
        console.error("Invalid coordinates passed to doc.text()");
      }
  
      const supplierInfo = {
        'Koperasi': locationName,
        'Dapur': kitchenName,
        'Tanggal Cetak': new Date().toLocaleDateString('id-ID', {
          year: 'numeric',
          month: 'long',
          day: '2-digit',
        }),
      };
  
      const marginLeft = 10;
      const textYOffset = 20;
      const labelWidth = Math.max(
        ...Object.keys(supplierInfo).map((key) => doc.getTextWidth(`${key}   `))
      );
  
      let yOffset = textYOffset;
      Object.entries(supplierInfo).forEach(([key, value]) => {
        // Ensure the text and coordinates are valid before calling doc.text()
        if (typeof key === 'string' && typeof value === 'string' && !isNaN(marginLeft) && !isNaN(yOffset)) {
          doc.text(`${key}`, marginLeft, yOffset);
          const colonX = marginLeft + labelWidth;
          doc.text(':', colonX, yOffset);
          const valueX = colonX + 2;
          doc.text(value, valueX, yOffset);
  
          yOffset += 5;
        } else {
          console.error("Invalid values passed to doc.text()");
        }
      });
  
      const iconWidth = 23;
      const iconHeight = 18;
      const iconX = pageWidth - iconWidth - 10;
      const iconY = textYOffset - 6;
  
      // Check if icon coordinates are valid
      if (!isNaN(iconX) && !isNaN(iconY)) {
        doc.addImage(iconBase64, 'PNG', iconX, iconY, iconWidth, iconHeight);
      } else {
        console.error("Invalid icon coordinates passed to doc.addImage()");
      }
    };
  
    let yOffset = 40;
    const totalPageHeight = doc.internal.pageSize.height;
    let pageNumber = 1;
  
    const addFooter = (currentPage, totalPages) => {
      const footerText = `Page ${currentPage} of ${totalPages}`;
      doc.setFontSize(10);
      // Check if footer text position is valid
      if (!isNaN(doc.getTextWidth(footerText))) {
        doc.text(footerText, pageWidth - doc.getTextWidth(footerText) - 10, totalPageHeight - 10);
      } else {
        console.error("Invalid footer text position");
      }
    };
  
    addHeader(doc, pageWidth, locationName, kitchenName);
  
    // Group items by `delivery_date`
    const groupedItems = data.reduce((acc, item) => {
      const dateKey = item.delivery_date;
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push({
        ingredient_name: item.ingredient_name,
        qty_request: parseFloat(item.qty_request) || 0,
        ingredient_value: parseFloat(item.ingredient_value) || 0,
        uoq_code: item.uoq_code,
        price_unit: parseFloat(item.ingredient_value) || 0,
        price_total: (parseFloat(item.qty_request) || 0) * (parseFloat(item.ingredient_value) || 0),
        order_qty: parseFloat(item.order_qty) || 0,
        qty: parseFloat(item.qty) || 0,
      });
      return acc;
    }, {});
  
    // Initialize grand total
    let grandTotal = 0;
  
    // Loop through grouped items
    Object.entries(groupedItems).forEach(([deliveryDate, items], index) => {
      const sectionHeight = items.length * 5 + 26;
  
      // Check for page break
      if (yOffset + sectionHeight > totalPageHeight - 20) {
        doc.addPage();
        yOffset = 40;
        pageNumber += 1;
        addHeader(doc, pageWidth, locationName, kitchenName);
      }
  
      // Calculate section subtotal
      const sectionSubtotal = items.reduce(
        (sum, item) => sum + item.price_total,
        0
      );
      grandTotal += sectionSubtotal; // Add to grand total
  
      // Draw gray border for the section
      doc.setDrawColor(200, 200, 200);
      doc.rect(10, yOffset, pageWidth - 20, sectionHeight, 'S');
  
      // Add delivery date
      doc.setFontSize(10);
      doc.text(
        `Delivery Date: ${new Date(deliveryDate).toLocaleDateString('id-ID', {
          year: 'numeric',
          month: 'long',
          day: '2-digit',
        })}`,
        15,
        yOffset + 5
      );
  
      yOffset += 7;
  
      // Add table for items
      doc.autoTable({
        startY: yOffset,
        head: [
          ['#', 'Bahan', 'Terkirim', 'Diterima Pengirim', 'Diterima Dapur'],
        ],
        body: items.map((item, index) => [
          `${index + 1}.`, // Numbering - Center
          item.ingredient_name || '-', // Ingredient Name - Left
          `${formatNumber(item.qty)} ${item.uoq_code || '-'}`, // Delivered Quantity - Right
          '[   ]', // Empty checkbox for "Diterima Supir"
          '[   ]', // Empty checkbox for "Diterima Dapur"
        ]),
        columnStyles: {
          0: { halign: 'center', cellWidth: '5%' }, // Numbering - Center
          1: { halign: 'left', cellWidth: 100 },   // Ingredient Name - Left
          2: { halign: 'center', cellWidth: '30%' }, // Delivered Quantity - Center
          3: { halign: 'center', cellWidth: '10%' }, // Diterima Supir - Center
          4: { halign: 'center', cellWidth: '10%' }, // Diterima Dapur - Center
        },
        styles: {
          cellPadding: 1,
          fontSize: 8,
          overflow: 'linebreak',
          font: 'Roboto',
        },
        headStyles: {
          fillColor: [220, 220, 220], // Light gray header background
          textColor: [0, 0, 0], // Black text
          fontStyle: 'bold',
          halign: 'center', // Default: Center-align all headers
        },
        // Override only the 'Bahan' column to be left-aligned
        didParseCell: function (data) {
          if (data.row.section === 'head' && data.column.index === 1) {
            data.cell.styles.halign = 'left';
          }
        }
      });
      
      // Update yOffset for next section
      yOffset = doc.lastAutoTable.finalY + 5;
  
      // Set font size to 8 for subtotal
      doc.setFontSize(8);
      yOffset += 10; // Adjust yOffset for next section
    });
// Add Signature Section
const signatureY = yOffset + 20;
const lineWidth = 50; // Keep lines equal
const spaceBetween = 10; // Space between lines

// Calculate positions dynamically
const receiverX = pageWidth - lineWidth - 10; // Adjust right-side position
const senderX = receiverX - lineWidth - spaceBetween; // Ensure spacing between lines

// Set font and alignment for the text
doc.setFontSize(10);
doc.text("Pihak Pengirim", senderX + lineWidth / 2, signatureY, { align: "center" });
doc.text("Pihak Penerima", receiverX + lineWidth / 2, signatureY, { align: "center" });

// Draw equal-width signature lines
doc.line(senderX, signatureY + 20, senderX + lineWidth, signatureY + 20); // Sender Line
doc.line(receiverX, signatureY + 20, receiverX + lineWidth, signatureY + 20); // Receiver Line


  
    // Display grand total
    const pageCount = doc.internal.getNumberOfPages();
  
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addFooter(i, pageCount);
    }
  
    doc.save(`${kitchenName}_DeliveryOrder.pdf`);
  };
  


  return (
    <div className="p-10 flex flex-col gap-6">
      <div className="flex flex-col items-center gap-4">
        <div className="border-t border-gray-400 w-full flex-1"></div>
        <div className="flex flex-col w-full">
          <p className="text-3xl font-medium">Delivery Order</p>
          <div className="pb-4">
            {(() => {
              //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);
              return `${new Date(startDate).toLocaleDateString("id-ID", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              })} 
              `;
              //  ${new Date(endDate).toLocaleDateString("id-ID", { 
              //   year: "numeric",
              //   month: "long",
              //   day: "2-digit",
              // })}

              // `;
            })()}
          </div>
          </div>
          <div className="border-t border-gray-400 w-full flex-1"></div>
        {/* <div className="flex flex-row w-full items-center justify-start">
          <div className="font-semibold">Tanggal:</div>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            customInput={
              <CustomInput
                value={selectedDate.toLocaleDateString("id-ID", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
                isOpen={isOpen}
              />
            }
            onCalendarOpen={() => setIsOpen(true)}
            onCalendarClose={() => setIsOpen(false)}
            dateFormat="yyyy-MM-dd"
            filterDate={(date) => {
              const day = date.getDay();
              return day !== 0 && day !== 6; // Disable weekends
            }}
          />
        </div> */}
          {/* <button
          className="w-1/2 px-3 py-4 bg-merah-no text-white rounded-[50px] hover:bg-merah-hover uppercase"
          onClick={handleSubmit}
        >
          Buat Delivery Order
        </button> */}
      </div>
 {/* Add the Download All as PDF button */}
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="overflow-x-auto">
        <button
           className="px-4 py-2 bg-green-500 text-white rounded mb-6"
             style={{
               width: `${"Download All as PDF ".length}ch`,
             }}
           onClick={async () => {
             // Iterate through all groups and download PDFs sequentially
             for (const [groupIndex, group] of Object.values(
               [...data]
                 .sort((a, b) => a.kitchen_id - b.kitchen_id) // Sort by kitchen_id
                 .reduce((groups, item) => {
                   // Group data by kitchen_id
                   if (!groups[item.kitchen_id]) {
                     groups[item.kitchen_id] = [];
                   }
                   groups[item.kitchen_id].push(item);
                   return groups;
                 }, {})
             ).entries()) {
               const firstItem = group[0]; // Take the first item to get the kitchen details
               const fileName = `Order_${firstItem.kitchen_id}_${firstItem.kitchen_name}.pdf`;
       
               await handleDownloadPDF(firstItem.location_name, firstItem.kitchen_name, firstItem.kitchen_id, group,);
             }
           }}
         >
           Download All as PDF
         </button>
          {data.length > 0 ? (
            <table className="fixed-table border-collapse w-full text-left">
              <thead>
                <tr className="bg-white">
                  {kitchenParam ? (""
                // <th className="border-b border-gray-400 px-4 py-2 uppercase rounded-tl-[15px]">No</th>
                  ) : (
                    <th className="border-b border-gray-400 px-4 py-2 uppercase rounded-tl-[15px]">Dapur</th>
                  ) }
                  <th className="border-b border-gray-400 px-4 py-2 uppercase"></th>
                <th className="border-b border-gray-400 px-4 py-2 uppercase rounded-tl-[15px]">Bahan</th>
                <th className="border-b border-gray-400 px-4 py-2 uppercase  text-right px-10" >Pengiriman</th>
                <th className="border-b border-gray-400 px-4 py-2 uppercase text-center" >Permintaan</th>
                <th className="border-b border-gray-400 px-4 py-2 uppercase text-center" ></th>
                  
                  
                  <th className="border-b border-gray-400 px-4 py-2 uppercase text-center rounded-tr-[15px]">
                    Download PDF
                  </th>
                </tr>
              </thead>
              <tbody>
  {
    Object.values(
      [...data]
        .sort((a, b) => a.kitchen_id - b.kitchen_id) // Sort by kitchen_id
        .reduce((groups, item) => {
          // Group data by kitchen_id
          if (!groups[item.kitchen_id]) {
            groups[item.kitchen_id] = [];
          }
          groups[item.kitchen_id].push(item);
          return groups;
        }, {})
    ).map((group, groupIndex) => {
      // Determine the background color for the group
      const bgColor = groupIndex % 2 === 0 ? "bg-gray-200" : "bg-white";

      return group.map((item, index) => {
        const isFirstRow = index === 0;
        const rowSpan = group.length;

        return (
          <tr key={`${item.kitchen_id}-${index}`} className={`${bgColor} bg-opacity-50`}>
            {kitchenParam ? (
            <td className="border-b border-gray-400 px-4 py-2 text-right">{index+1}.</td>
          ) : (
           
             isFirstRow && (
              <td className="border-b border-gray-400 px-4 py-2" rowSpan={rowSpan}>
                {item.kitchen_name}
              </td>
            )
            )}{kitchenParam ? "" : (
              <td className="border-b border-gray-400 px-4 py-2 text-right">{index+1}.</td>)
             }
             <td className="border-b border-gray-400 px-4 py-2">
               
             {item.ingredient_name}
             </td>
            <td className="border-b border-gray-400 px-4 py-2 text-right">
              
            {parseFloat(item.order_qty)}
            </td>

            

            <td className="border-b border-gray-400 px-10 py-2 text-right">
            {formatNumber(item.qty)}
            </td>
            <td className="border-b border-gray-400 py-2 text-left pe-20">
            {item.uoq_code}
            </td>

            {isFirstRow && (
              <td className="border-b border-gray-400 px-4 py-2 text-center" rowSpan={rowSpan}>
                <button
                  className="px-4 py-2 bg-blue-500 text-white rounded"
                  onClick={() => handleDownloadPDF(item.location_name, item.kitchen_name, item.kitchen_id, group)}
                >
                  Download PDF
                </button>
              </td>
            )}
          </tr>
        );
      });
    })
  }
</tbody>

            </table>
          ) : (
            <p>No data available for the selected date.</p>
          )}
        </div>
      )}

      
    </div>
  );
}
